import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface TranscriptErrorFallbackProps {
  error: Error;
  resetError: () => void;
}

/**
 * Custom error fallback component specifically for the Transcript module.
 * Provides a user-friendly error message and recovery options.
 */
const TranscriptErrorFallback: React.FC<TranscriptErrorFallbackProps> = ({ error, resetError }) => {
  return (
    <div className="min-h-[400px] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex items-center mb-4">
            <ExclamationTriangleIcon className="h-8 w-8 text-red-500 mr-3" />
            <h2 className="text-xl font-semibold text-gray-900">
              Error Loading Transcripts
            </h2>
          </div>
          
          <p className="text-gray-600 mb-4">
            We encountered an error while loading the transcript data. This might be a temporary issue.
          </p>
          
          {process.env.NODE_ENV === 'development' && (
            <div className="mb-4 p-3 bg-red-50 rounded-md">
              <p className="text-sm text-red-800 font-mono">
                {error.message}
              </p>
            </div>
          )}
          
          <div className="flex space-x-3">
            <button
              onClick={resetError}
              className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.href = '/hub'}
              className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TranscriptErrorFallback;